import "get-root-node-polyfill/implement";
import "core-js";
import "regenerator-runtime/runtime";
import "whatwg-fetch";
import { registerRootComponent } from "expo";
import App from "./App";
registerRootComponent(App);
